import { render, staticRenderFns } from "./BaseChat.vue?vue&type=template&id=16b53601&scoped=true&lang=pug"
import script from "./BaseChat.vue?vue&type=script&lang=ts"
export * from "./BaseChat.vue?vue&type=script&lang=ts"
import style0 from "./BaseChat.vue?vue&type=style&index=0&id=16b53601&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b53601",
  null
  
)

export default component.exports